var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.25L10.2567 9.54525C10.0279 9.67816 9.768 9.74817 9.50337 9.74817C9.23875 9.74817 8.97883 9.67816 8.75 9.54525L2 5.25M3.5 3H15.5C16.3284 3 17 3.67157 17 4.5V13.5C17 14.3284 16.3284 15 15.5 15H3.5C2.67157 15 2 14.3284 2 13.5V4.5C2 3.67157 2.67157 3 3.5 3Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d5617446ecf9492c2dddcbac2eedf591.svg";
export { ForwardRef as ReactComponent };